export const ActionType = {
  GetList: Symbol("GetProductList"),
  Update: Symbol("UpdateProduct"),
  UpdateList: Symbol("UpdateProductList"),
  UpdateStatus: Symbol("UpdateProductStatus"),
};
